import { LoginResponse } from '../auth';

export class UserUtils {
  static authDataCached: LoginResponse | undefined = undefined;

  static getUserId = (authData?: LoginResponse) => this.parseAccessToken(authData)?.sub;

  private static parseAccessToken = (authData?: LoginResponse) => {
    const data = authData || this.authDataCached;
    if (data == null) return undefined;
    const result = JSON.parse(atob(data.token.split('.')[1]));
    return result;
  };
}
